import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';
import { cn } from '../../lib/utils';
import { Spinner } from './spinner';

const Switch = ({ className, loading, ...props }: React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & { loading?: boolean }) => (
  <div className='inline-flex items-center gap-2'>
    {loading ? (
      <Spinner className='w-5 h-5' />
    ) : (
      <SwitchPrimitives.Root
        className={cn(
          'peer inline-flex h-5 w-10 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input',
          className,
        )}
        {...props}
      >
        <SwitchPrimitives.Thumb
          className={cn('pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0')}
        />
      </SwitchPrimitives.Root>
    )}
  </div>
);
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
